import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { AppState } from '@/store/store';
import {
  httpDelete,
  httpGet,
  httpPut,
} from '@/utils/helpers/httpHelperPartner';
import CONFIG from 'config';

export type CampaignType = {
  id: string;
  campaignEndDate: string;
  campaignStartDate: string;
  cities: string;
  discountedPrice: number;
  name: string;
  price: number;
  status: string;
  subCategoryName: string;
  images: [{ uploadedImagePath: string; order: number }];
};

export const fetchPartnerCampaigns: any = createAsyncThunk(
  'requests/fetchPartnerCampaigns',
  async (arg, { getState }) => {
    const { partnerCampaign }: any = getState();
    const { data } = await httpGet(
      partnerCampaign.filter !== 'all'
        ? `${CONFIG.ENDPOINTS.partnerCampaigns}?page=${partnerCampaign.page}&limit=${partnerCampaign.numPerPage}&status=${partnerCampaign.filter}`
        : `${CONFIG.ENDPOINTS.partnerCampaigns}?page=${partnerCampaign.page}&limit=${partnerCampaign.numPerPage}`

      // `${CONFIG.ENDPOINTS.partnerRequests}?page=${requests.page}&limit=${requests.numPerPage}`
    );

    return data;
  }
);

export const fetchDeleteCampaign: any = createAsyncThunk(
  'requests/fetchDeleteCampaign',
  async (id: string, { dispatch }) => {
    const { data } = await httpDelete(
      `${CONFIG.ENDPOINTS.deleteCampaign}${id}`
    );
    dispatch(deleteCampaign(id));

    return data;
  }
);

export const fetchPassiveCampaign: any = createAsyncThunk(
  'requests/fetchPassiveCampaign',
  async (id: string, { dispatch }) => {
    const { data } = await httpPut(
      `${CONFIG.ENDPOINTS.singleCampaign}${id}/statuspassive`,
      {}
    );
    dispatch(passiveCampaign({ id: id, changes: { status: 'Süresi doldu' } }));

    return data;
  }
);

const partnerCampaignAdapter = createEntityAdapter<CampaignType>({
  selectId: (campaign) => campaign.id,
});

export const partnerCampaignSlice = createSlice({
  name: 'partnerCampaigns',
  initialState: partnerCampaignAdapter.getInitialState({
    loading: true,
    error: false,
    page: 1,
    numPerPage: 10,
    sort: 'createdAt',
    direction: 'desc',
    totalCount: null,
    filter: 'all',
  }),
  reducers: {
    deleteCampaign: partnerCampaignAdapter.removeOne,
    passiveCampaign: partnerCampaignAdapter.updateOne,

    changeFilter: (state, action) => {
      state.filter = action.payload;
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
    changeNumPerPage: (state, action) => {
      state.numPerPage = action.payload;
    },
    changeSort: (state, action) => {
      state.sort =
        action.payload.direction === 'none'
          ? ''
          : `${action.payload.name}_${action.payload.direction}`;
    },
    changeAllFilters: (state, action) => {
      state.sort = action.payload.sort;
      state.page = action.payload.page;
      state.numPerPage = action.payload.perPage;
    },
  },
  extraReducers: {
    [fetchPartnerCampaigns.pending](state) {
      state.loading = true;
    },
    [fetchPartnerCampaigns.fulfilled](state, { payload }) {
      partnerCampaignAdapter.setAll(
        state,
        payload?.data?.items ? payload.data.items : []
      );
      state.totalCount = payload.data.totalCount;
      state.loading = false;
    },
    [fetchPartnerCampaigns.rejected](state) {
      state.loading = false;
      state.error = true;
    },
  },
});

export const {
  changePage,
  changeNumPerPage,
  changeAllFilters,
  changeFilter,
  deleteCampaign,
  passiveCampaign,
} = partnerCampaignSlice.actions;
export const partnerCampaignSelectors =
  partnerCampaignAdapter.getSelectors<AppState>(
    (state) => state.partnerCampaign
  );
partnerCampaignAdapter.getSelectors<AppState>((state) => state.partnerCampaign);

// export const { selectAll, selectById, selectIds, selectEntities } = companySelectors;

export default partnerCampaignSlice.reducer;
